import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';

@Injectable()
export class LoginGuard implements CanActivate {
    constructor( private sessionSt: LocalStorageService,protected router: Router) {}

    canActivate() {
       // REDIRECT TO LOGIN SCREEN IF NOT LOGGED IN -- WILL APPLY LATER
    if(this.sessionSt.retrieve('login_token') == null) {
      this.router.navigateByUrl("/");
    }

    
    return true;

    
    }
}